module.exports = __webpack_public_path__ + "img/ashley_yetman.a7ef2c67.jpg";